export default function SponsorList() {
	return (
		<section className="sponsor-section">
			<header>
				<h2>Myelinated Sponsors</h2>
				<p>May the force be with you</p>
			</header>

			<p>[TBD]</p>
		</section>
	);
}
